import {
  Box,
  Grid,
  Button,
  Typography,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetUserCountries,
  setState,
  GetCustomerNumber,
  GetSalesOrderNumberLineItem,
  getDataSourcesRecords,
  ModifyDataSourcesRows,
  reset,
} from "../centralAdminSlice";
import { DataGridPro } from "@mui/x-data-grid-pro";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import SharedComponent from "../SharedComponent";
import MultiSelect from "./MultiSelect";
import MultiSelectSalesOrder from "./MultiSelectSalesOrder";
import MultiSelectLineItem from "./MultiSelectLineItem";
import CollapseSection from "../../../components/ui/CollapseSection";
import moment from "moment";
import muiConfig from '../../../assets/MuiConfig.json'

export default function OrderModification() {
  const dispatch = useDispatch();
  const centralAdmin = useSelector((state) => state.centralAdmin);
  const {
    countries,
    selectedCountry,
    selectedCountryID,
    CustomerNumberList,
    selectedPeriod,
    SalesOrderList,
    LineItemList,
    selectedDataCustomerIds,
    selectedDataSalesOrders,
    selectedDataLineItems,
    OrderModRecords,
    isLoading,
    selectedRowIds,
  } = centralAdmin;

  const loginState = useSelector((store) => store.login);
  const { globalSelectedCountryName,globalSelectedCountryID,} = loginState      

  const [selectedRowID, setSelectedRowID] = useState([]);

  useEffect(() => {
    debugger;
    dispatch(reset("OnRefresh"));
    if (countries.length <= 0) {
      dispatch(GetUserCountries({ method: "Get" }));
    }
    if(globalSelectedCountryName !==null && globalSelectedCountryName !== "" ){
      dispatch(setState("selectedCountry", globalSelectedCountryName));
      dispatch(setState("selectedCountryID", globalSelectedCountryID));
      dispatch(setState("CAGlobalselectedCountryID", globalSelectedCountryID));
      dispatch(GetCustomerNumber(globalSelectedCountryID));

    }
    else{
      dispatch(setState("selectedCountry", ""));
      dispatch(setState("selectedCountryID", null));
  }     
  }, []);

  const handlePeriodChange = (e) => {
    const period = e.target.value;
    dispatch(reset("OnPeriodChange"));
    dispatch(setState("selectedPeriod", period));
    if(selectedCountryID === null || selectedCountryID === undefined || selectedCountryID === ""){
      return;
    }
    let obj = {
      selectedPeriod: period,
      selectedSalesOrder: "",
    };
    dispatch(GetSalesOrderNumberLineItem(obj));
  };

  const handleCountryChange = (e) => {
    dispatch(reset("OnCountryChange"));
    const name = e.target.value;

    const countryID = countries.find(
      (country) => country.countryName === name
    ).countryID;
    dispatch(GetCustomerNumber(countryID));
    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));
  };

  const handleDisplay = () => {
    if (!selectedCountry) {
      dispatch(setState("isFailed_Info", "Please select a country."));
      dispatch(setState("isFailed", true));
      return;
    }
    if (selectedDataCustomerIds.length <= 0) {
      dispatch(setState("isFailed_Info", "Please select a customer."));
      dispatch(setState("isFailed", true));
      return;
    }

    if (!selectedPeriod) {
      dispatch(setState("isFailed_Info", "Please select a role."));
      dispatch(setState("isFailed", true));
      return;
    }
    if (selectedDataSalesOrders.length <= 0) {
      dispatch(setState("isFailed_Info", "Please select a sales order."));
      dispatch(setState("isFailed", true));
      return;
    }
    if (selectedDataLineItems.length <= 0) {
      dispatch(setState("isFailed_Info", "Please select a line item number."));
      dispatch(setState("isFailed", true));
      return;
    }

    let obj = {
      countryID: selectedCountryID,
      period: selectedPeriod,
      customerNumber: selectedDataCustomerIds.join(),
      salesOrder: selectedDataSalesOrders.join(),
      lineItem: selectedDataLineItems.join(),
    };
    dispatch(getDataSourcesRecords(obj));
  };

  const ModifyOrder = () => {
    let obj = {
      countryID: selectedCountryID,
      period: selectedPeriod,
      customerNumber: selectedDataCustomerIds.join(),
      salesOrder: selectedDataSalesOrders.join(),
      lineItem: selectedDataLineItems.join(),
    };
    dispatch(ModifyDataSourcesRows(selectedRowID)).then(() => {
      dispatch(getDataSourcesRecords(obj));
    });
  };

  const onRowsSelectionHandler = (ids) => {
    dispatch(setState("selectedRowIds", ids));
    setSelectedRowID(ids);
  };

  const columns = [
    {
      field: "period",
      headerName: "Period",
      flex: 1.8,
      valueFormatter: (params) => moment(params.value).format('DD/MM/YYYY')
    },
    {
      field: "attribute9",
      headerName: "Sales Order Number",
      flex: 1.5,
    },

    {
      field: "attribute10",
      headerName: "Line Item Number",
      flex: 1.5,
    },

    {
      field: "status",
      headerName: "Order Status",
      flex: 1.5,
    },
  ];
  return (
    <CollapseSection title="Order Status Modification">
      <Box mt={5}>
        <Grid container columns={12} columnGap={2} rowGap={2}>
          <Grid item sm={1.95}>
            <TextField
              variant="outlined"
              label="Country"
              select={countries.length > 0 ? true : false}
             // value={countries.length > 0 ? selectedCountry : ""}
             value = {selectedCountry}
              onChange={handleCountryChange}
              fullWidth
              size="small"
            >
              {countries.length > 0
                ? countries.map((country, index) => {
                    return (
                      <MenuItem
                        key={country.countryID}
                        value={country.countryName}
                      >
                        {country.countryName}
                      </MenuItem>
                    );
                  })
                : null}
            </TextField>
          </Grid>
          <Grid item sm={1.95}>
            <MultiSelect customers={CustomerNumberList} />
          </Grid>
          <Grid item sm={1.95}>
            <TextField
              variant="outlined"
              label="Period"
              select={true}
              value={selectedPeriod ? selectedPeriod : ""}
              onChange={handlePeriodChange}
              size="small"
              fullWidth
            >
              <MenuItem value="1">Current</MenuItem>
              <MenuItem value="0">Previous</MenuItem>
            </TextField>
          </Grid>
          {selectedPeriod !== "" && (
            <Grid item sm={1.95}>
              <MultiSelectSalesOrder SalesOrder={SalesOrderList} />
            </Grid>
          )}
          {selectedDataSalesOrders.length > 0 && (
            <Grid item sm={1.95}>
              <MultiSelectLineItem LineItem={LineItemList} />
            </Grid>
          )}

          <Grid item sm={1.5}>
            <Box 
            justifyContent="center" display="flex">
              <Button 
                sx={{
                  bgcolor: "darkred.light",
                  color: "white.main",
                  textTransform: "none",
                  fontWeight: "bold",
                  mt: 1,
                  mr: 2,
                  "&:hover": {
                    bgcolor: "darkred.main",
                  },
                }}
              variant="contained" onClick={handleDisplay}>
                Search
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress />
      </Backdrop>
      <SharedComponent />
      {OrderModRecords.length > 0 && (
        <Box
          mt={2}
          sx={{
            width: "100%",
            minHeight: "200px",
            display: OrderModRecords ? "block" : "none",
          }}
        >
          <DataGridPro
            style={{ maxHeight: "calc(100vh - 130px)" }}
            disableColumnMenu
            sx={{
              "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal",
                lineHeight: "normal",
              },
              "& .MuiDataGrid-columnHeader": {
                position: "sticky",
              },
              "& .MuiDataGrid-columnHeaders": {
                maxHeight: "168px !important",
              },
            }}
            rowHeight={70}
            rows={OrderModRecords || []}
            columns={columns}
            getRowId={(row) => row?.dataSourceRowID}
            onRowSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
            initialState={{
              pagination: { paginationModel: { pageSize:20, page:0 }}
            }}
            pagination
            pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}	
            checkboxSelection
            disableRowSelectionOnClick
          />
        </Box>
      )}
      <Box my={2} />
      <Grid
        container
        columns={12}
        justifyContent="flex-end"
        alignItems="right"
        my={2}
      >
        <Grid>
          {selectedRowIds.length > 0 && (
            <Button 
            variant="contained"
            sx={{
              bgcolor: "darkred.light",
              color: "white.main",
              textTransform: "none",
              fontWeight: "bold",
              mt: 1,
              mr: 2,
              "&:hover": {
                bgcolor: "darkred.main",
              },
            }}
            onClick={ModifyOrder}>
              Modify Order Status
            </Button>
          )}
        </Grid>
      </Grid>
    </CollapseSection>
  );
}
